module.exports = __webpack_public_path__ + "static/media/newMachineInto.09a22e13.png";